import * as types from '../types';
import { IMfaApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class MfaHttpApi extends HttpApi implements IMfaApi {
  async getMfaStatus(): Promise<types.MfaStatus> {
    return (await this.http.get<types.APIResponse<types.MfaStatus>>('/mfa/status')).data.data;
  }

  async startMfaEnrollment(password: string): Promise<types.MfaEnrollmentStart> {
    return (await this.http.post<types.APIResponse<types.MfaEnrollmentStart>>('/mfa/enrollment', { password })).data.data;
  }

  async confirmMfaEnrollment(code: string): Promise<types.MfaEnrollmentConfirm> {
    return (await this.http.post<types.APIResponse<types.MfaEnrollmentConfirm>>('/mfa/enrollment/confirm', { code })).data.data;
  }

  async disableMfa(reauth: types.MfaReauth): Promise<void> {
    await this.http.post('/mfa/disable', reauth);
  }

  async regenerateMfaRecoveryCodes(reauth: types.MfaReauth): Promise<string[]> {
    return (await this.http.post<types.APIResponse<{ recoveryCodes: string[] }>>('/mfa/recovery-codes', reauth)).data.data.recoveryCodes;
  }

  async getMfaPolicy(): Promise<types.MfaPolicy> {
    return (await this.http.get<types.APIResponse<types.MfaPolicy>>('/mfa/policy')).data.data;
  }

  async updateMfaPolicy(requiredRoles: types.MfaEnforceableRole[]): Promise<types.MfaPolicy> {
    return (await this.http.put<types.APIResponse<types.MfaPolicy>>('/mfa/policy', { requiredRoles })).data.data;
  }

  async listUserMfaStatuses(): Promise<types.UserMfaStatus[]> {
    return (await this.http.get<types.APIResponse<types.UserMfaStatus[]>>('/mfa/users')).data.data;
  }

  async resetUserMfa(userId: string, reauth: types.MfaReauth): Promise<{ hadMfa: boolean }> {
    return (await this.http.post<types.APIResponse<{ hadMfa: boolean }>>(`/mfa/users/${encodeURIComponent(userId)}/reset`, reauth)).data.data;
  }
}
